import { render, staticRenderFns } from "./retail__form.vue?vue&type=template&id=9865aa50"
import script from "./retail__form.vue?vue&type=script&lang=js"
export * from "./retail__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports